import jwtDecode from "jwt-decode";
import { createContext, useContext, useEffect, useRef, useState } from "react";
import { useQueryClient } from "react-query";
import { useParams } from "react-router-dom";
import useAtosService from "../../../../../../api/services/atos/atos";
import { RecPecaI } from "../../../../../../api/services/atos/atos.interface";
import { getConsultarCredenciaisPje } from "../../../../../../api/services/consultaCredenciais/consultaCredenciaisPje-Service";
import useJvrisESignerService from "../../../../../../api/services/jvrisesigner";
import useModelosPecaService from "../../../../../../api/services/modelos-peca";
import { ModeloPecaI } from "../../../../../../api/services/modelos-peca/interfaces";
import usePecasService from "../../../../../../api/services/pecas";
import {
  PecaI,
  SendAnexoPecaI,
} from "../../../../../../api/services/pecas/interfaces";
import { getProcessData } from "../../../../../../api/services/processData/processData";
import useProcessosService from "../../../../../../api/services/Processos";
import useProcessosPjeService from "../../../../../../api/services/processos-pje";
import { TiposProcessoPJEI } from "../../../../../../api/services/processos-pje/interface";
import usePartesService from "../../../../../../api/services/Processos/Partes";
import {
  HotToastError,
  HotToastSucess,
  HotToastWarning,
} from "../../../../../../components/HotToastFuncs";
import { SharedState } from "../../../../../../context/SharedContext";
import { useAct } from "../../../../../../hooks/useAct";
import { ModelTypeSelectI, PecasContextI } from "./interfaces";
import { formatarPeca } from "./utils/pecaHtml";

const PecasContext = createContext<PecasContextI>({} as PecasContextI);

export const PecasProvider = (props: any) => {
  const [modelTypeFilter, setModelTypeFilter] = useState<ModelTypeSelectI>({
    value: -1,
    label: "",
  });
  const [currModel, setCurrModel] = useState<ModeloPecaI>();
  const [modelTitle, setModelTitle] = useState("");
  const {
    getModelosPorIDAutorTipoDoc,
    modelos,
    sendModelo,
    updateModelo,
    getModeloById,
    modelo,
    getModelos,
    loadingModelos: loadingModelosPecas,
  } = useModelosPecaService();
  const { getTiposProcessosPJE, tiposProcessoPJE, loadingTiposProcessoPJE } =
    useProcessosPjeService();
  const {
    salvarPeca,
    assinarPeca,
    finalizarPeca,
    updatePeca,
    adicionarAnexo,
    getAnexosPeca,
    anexosPeca,
  } = usePecasService();
  const {
    pecasFinalizadas,
    getPecasFinalizadas,
    get: getAto,
    recuperarPeca,
    atualizarRecPecaLocal,
    recPeca,
    concluirAtuacao,
    anexos: anexosAto,
    getAnexosResposta,
    anexosResposta,
    getAnexos: getAnexosAto,
  } = useAtosService();

  const { get: getPartes, partes } = usePartesService();

  const { openSigner, openSignerReadOnly } = useJvrisESignerService();

  const [finlPeca, setFinlPeca] = useState<PecaI>();
  const ultimaPecaSalvaRef = useRef<Partial<RecPecaI & PecaI> | null>(null);
  const ultimaPecaSalvaExpiraEmRef = useRef(0);
  const modeloInicialAplicadoRef = useRef(false);

  const tokenString = localStorage.getItem("token")!;
  const token: any = jwtDecode(tokenString);
  const userId: string = token["Jvris.User.Id"];
  const { idModelo, idAto } = useParams();
  const { selectedUser } = SharedState();
  const queryClient = useQueryClient();
  const { get: getProcesso, processo } = useProcessosService();
  const { act } = useAct(idAto);

  useEffect(() => {
    idAto && act && getProcesso(act.data.idProcesso);
  }, [act]);
  useEffect(() => {
    //processo&& seed();
    seed();
  }, [processo]);

  useEffect(() => {
    //console.log("currModel", currModel);
    if (currModel && currModel.txDescricao)
      setModelTitle(currModel.txDescricao);
  }, [currModel]);

  useEffect(() => {
    if (idModelo && modelos) {
      if (modeloInicialAplicadoRef.current) return;
      if (ultimaPecaSalvaRef.current) return;
      if (props.comProcesso && recPeca === undefined) return;
      if (props.comProcesso && recPeca !== "NotFound") return;
      if (props.comProcesso && finlPeca) return;

      const model = modelos.find((model) => model.id.toString() === idModelo);
      if (!model) return;

      modeloInicialAplicadoRef.current = true;
      updateCurrModel(model);
    }
  }, [idModelo, modelos, recPeca, finlPeca, props.comProcesso]);

  /* useEffect(() => {
        //console.log("modelTitle", modelTitle);
    }, [modelTitle]) */

  useEffect(() => {
    if (tiposProcessoPJE) {
      if (recPeca != "NotFound" && recPeca != undefined) {
        getDataPecaFound(recPeca, false, !ultimaPecaSalvaRef.current);
      } else if (recPeca == "NotFound" && finlPeca) {
        getDataPecaFound(finlPeca, false, !ultimaPecaSalvaRef.current);
      } else if (recPeca == "NotFound" && !finlPeca) {
        getModelos().catch((err) => {});
      }
    }
  }, [recPeca, tiposProcessoPJE, finlPeca]);

  useEffect(() => {
    if (pecasFinalizadas && pecasFinalizadas.length && recPeca == "NotFound") {
      updateFinalPeca(pecasFinalizadas[0]);
    }
  }, [recPeca, pecasFinalizadas]);

  async function seed() {
    if (processo) {
      recuperarPeca(act.data.id);

      getPecasFinalizadas(act.data.id);
      getPartes(act.data.idProcesso);
      getAnexosAto(act.data.id);
      getAnexosResposta(act.data.id);
      getPecasFinalizadas(act.data.id);

      if (
        recPeca != "NotFound" &&
        recPeca != undefined &&
        typeof recPeca != "string"
      ) {
        getAnexosPeca(recPeca?.id);
      } else getAnexosPeca(processo?.idPeca);
    } else {
      getModelos();
    }
    getTiposProcessosPJE();
  }

  function invalidateDashboardProcuradorQueries(...idsProcurador: any[]) {
    const ids = new Set(
      idsProcurador
        .concat(selectedUser?.id, parseInt(userId))
        .map((id) => Number(id))
        .filter((id) => !Number.isNaN(id) && id > 0),
    );

    ids.forEach((idProcurador) => {
      queryClient.invalidateQueries([
        `distributions-attorney-${idProcurador}`,
        idProcurador,
      ]);
      queryClient.invalidateQueries([
        `inactions-attorney-${idProcurador}`,
        idProcurador,
      ]);
      queryClient.invalidateQueries([
        `redistributions-attorney-${idProcurador}`,
        idProcurador,
      ]);
    });
  }

  function getPecaMaisRecente(peca: any) {
    const ultimaPecaSalva = ultimaPecaSalvaRef.current;

    if (!peca || !ultimaPecaSalva?.txPeca) return peca;

    if (Date.now() > ultimaPecaSalvaExpiraEmRef.current) {
      ultimaPecaSalvaRef.current = null;
      return peca;
    }

    const mesmaPeca =
      (ultimaPecaSalva.id &&
        peca.id &&
        Number(ultimaPecaSalva.id) === Number(peca.id)) ||
      (ultimaPecaSalva.idAto &&
        peca.idAto &&
        Number(ultimaPecaSalva.idAto) === Number(peca.idAto));

    if (!mesmaPeca) return peca;

    if (peca.txPeca === ultimaPecaSalva.txPeca) {
      return peca;
    }

    return {
      ...peca,
      ...ultimaPecaSalva,
      id: peca.id ?? ultimaPecaSalva.id,
      idProcesso: peca.idProcesso ?? processo?.id,
      txNumeroProcesso: peca.txNumeroProcesso ?? processo?.txNumeroFormatado,
    };
  }

  function registrarPecaSalva(peca: Partial<RecPecaI & PecaI>) {
    const pecaSalva = {
      ...peca,
      idProcesso: peca.idProcesso ?? processo?.id,
      txNumeroProcesso: peca.txNumeroProcesso ?? processo?.txNumeroFormatado,
    };

    ultimaPecaSalvaRef.current = pecaSalva;
    ultimaPecaSalvaExpiraEmRef.current = Date.now() + 30000;
    if (pecaSalva.id) atualizarRecPecaLocal(pecaSalva as RecPecaI);
    getDataPecaFound(pecaSalva, true, false);
    invalidateDashboardProcuradorQueries(pecaSalva.idProcurador);
  }

  function preservarTextoEditorAtual(txPeca: string) {
    const pecaAtual =
      recPeca && recPeca !== "NotFound" && typeof recPeca !== "string"
        ? recPeca
        : finlPeca;
    const pecaAtualComProcesso = pecaAtual as
      | Partial<RecPecaI & PecaI>
      | undefined;

    const textoAtual = {
      ...pecaAtual,
      idAto: pecaAtualComProcesso?.idAto ?? +idAto,
      idProcesso: pecaAtualComProcesso?.idProcesso ?? processo?.id,
      txNumeroProcesso:
        pecaAtualComProcesso?.txNumeroProcesso ?? processo?.txNumeroFormatado,
      txDescricao: modelTitle,
      idTipoDocumento: modelTypeFilter.value,
      idProcurador:
        pecaAtualComProcesso?.idProcurador ||
        selectedUser?.id ||
        parseInt(userId),
      idUsuarioCadastro:
        pecaAtualComProcesso?.idUsuarioCadastro ?? currModel?.idUsuarioCadastro,
      txPeca,
    };

    ultimaPecaSalvaRef.current = textoAtual;
    ultimaPecaSalvaExpiraEmRef.current = Date.now() + 30000;

    setCurrModel((model) =>
      model
        ? {
            ...model,
            txDescricao: modelTitle,
            txModeloPeca: txPeca,
            idTipoDocumento: modelTypeFilter.value,
            txTipoDocumento: modelTypeFilter.label,
          }
        : model,
    );
  }

  function getDataPecaFound(
    peca: any,
    preservarPecaInformada = false,
    atualizarModelos = true,
  ) {
    if (!preservarPecaInformada) peca = getPecaMaisRecente(peca);

    const idTipoDocumento = peca.idTipoDocumento ?? modelTypeFilter.value;
    const txTipoDocumento =
      tiposProcessoPJE.find((tipo) => tipo.id == idTipoDocumento)
        ?.txTipoDocumento ||
      peca.txTipoDocumento ||
      modelTypeFilter.label ||
      "";

    updateModelTypeFilterValue({
      label: txTipoDocumento,
      value: idTipoDocumento,
    });
    updateCurrModel({
      id: peca.id,
      dtCadastro: peca.dtCadastro,
      hrCadastro: peca.hrCadastro,
      txDescricao: peca.txDescricao,
      txModeloPeca: peca.txPeca,
      idTipoDocumento,
      idUsuarioCadastro: peca.idUsuarioCadastro,
      txTipoDocumento,
      txAutor: "",
    });
    if (atualizarModelos) {
      getModelosPorIDAutorTipoDoc({
        idAutor:
          peca.idProcurador || peca.idProcurador > 0
            ? peca.idProcurador
            : selectedUser?.id || parseInt(userId),
        idTipoDocumento: peca.idTipoDocumento,
      }).catch((err) => {});
    }
    if (peca?.id) getAnexosPeca(peca.id);
  }

  function prepareModelList(modelsList: ModeloPecaI[]) {
    if (modelTypeFilter.label.length)
      modelsList = modelsList?.filter(
        (model) => model.txTipoDocumento == modelTypeFilter.label,
      );

    const modelsListOptions: ModelTypeSelectI[] = [];
    if (!modelsList) return modelsListOptions;
    modelsListOptions.push({
      label: "Selecione um modelo",
      value: -1,
    });
    modelsList.map((model: ModeloPecaI) => {
      modelsListOptions.push({
        value: model.id,
        //label: `${model.txDescricao}`
        label: `${model.txTipoDocumento} - ${model.txDescricao} - ${model.txAutor}`,
      });
    });

    return modelsListOptions;
  }

  function prepareModelListUser(modelsList: ModeloPecaI[]) {
    if (modelTypeFilter.label.length)
      modelsList = modelsList?.filter(
        (model) => model.txTipoDocumento == modelTypeFilter.label,
      );

    const modelsListOptions: ModelTypeSelectI[] = [];
    if (!modelsList) return modelsListOptions;
    modelsListOptions.push({
      label: "Selecione um modelo",
      value: -1,
    });
    modelsList.forEach((model: ModeloPecaI) => {
      if (token["Jvris.User.Name"] == model.txAutor) {
        modelsListOptions.push({
          value: model.id,
          label: `${model.txTipoDocumento} - ${model.txDescricao}`,
        });
      }
    });

    return modelsListOptions;
  }
  function prepareModelTypeList(modelsList: TiposProcessoPJEI[]) {
    const modelsListTypeOptions: ModelTypeSelectI[] = [];
    const goneTypes: string[] = [];
    if (!modelsList) return modelsListTypeOptions;
    modelsListTypeOptions.push({
      label: "Selecione um Tipo de Documento",
      value: -1,
    });
    for (let i = 0; i < modelsList.length; i++) {
      if (goneTypes.includes(modelsList[i].txTipoDocumento)) continue;
      goneTypes.push(modelsList[i].txTipoDocumento);

      modelsListTypeOptions.push({
        value: modelsList[i].id,
        label: modelsList[i].txTipoDocumento,
      });
    }

    return modelsListTypeOptions;
  }

  function updateCurrModel(model: ModeloPecaI) {
    if (!model) return;
    setCurrModel(model);
    updateModelTypeFilterValue({
      label: model.txTipoDocumento,
      value: model.idTipoDocumento,
    });
  }

  function updateModelTypeFilterValue(value: ModelTypeSelectI) {
    if (value.value == -1) {
      setModelTypeFilter({
        value: -1,
        label: "",
      });
      //getModelos();
    } else {
      setModelTypeFilter(value);
      //getModeloByTypeId(value.value);
    }

    if (!props.comProcesso) {
      setCurrModel({
        idTipoDocumento: value.value,
        txTipoDocumento: value.label,
        idUsuarioCadastro: parseInt(userId),
        txAutor: token["Jvris.User.Name"],
      } as any);
    }
  }

  function updateTitle(value: string) {
    setModelTitle(value);
  }

  function fieldsVerify(save?: boolean) {
    //console.log("modelTitle", modelTitle);
    if (!modelTitle) {
      HotToastWarning("Insira um título para o modelo");
      return false;
    }

    if (!currModel && !save) {
      //console.log("currModel", currModel);
      HotToastWarning("Selecione um modelo");
      return false;
    }
    if (!modelTypeFilter.label.length) {
      //console.log("modelTypeFilter", modelTypeFilter);
      HotToastWarning("Selecione um tipo de modelo");
      return false;
    }
    return true;
  }

  function SalvarPeca(text: string, onSaveCallback?: () => void) {
    if (!fieldsVerify(true)) return;

    const txPecaFormatada = formatarPeca(text);
    preservarTextoEditorAtual(txPecaFormatada);

    if (recPeca != "NotFound" && typeof recPeca != "string" && recPeca) {
      const recP: RecPecaI = recPeca;
      const pecaAtualizada = {
        ...recP,
        idTipoDocumento: modelTypeFilter.value,
        idModeloPeca: processo.idPeca,
        txDescricao: modelTitle,
        txPeca: txPecaFormatada,
      };

      updatePeca(pecaAtualizada)
        .then((res) => {
          registrarPecaSalva(
            typeof res === "object" && res
              ? { ...res, ...pecaAtualizada }
              : pecaAtualizada,
          );
          onSaveCallback && onSaveCallback();
          HotToastSucess("Peça atualizada com sucesso");
        })
        .catch((ERR) => HotToastError(ERR));
    } else {
      const novaPeca = {
        idAto: +idAto,
        txDescricao: modelTitle,
        idTipoDocumento: modelTypeFilter.value,
        idProcurador: selectedUser?.id || parseInt(userId),
        idModeloPeca: processo.idPeca,
        idUsuarioCadastro: parseInt(userId),
        txPeca: txPecaFormatada,
      };

      salvarPeca(novaPeca)
        .then((res) => {
          registrarPecaSalva(
            typeof res === "object" && res
              ? { ...res, ...novaPeca, id: res.id }
              : novaPeca,
          );
          HotToastSucess("Peça salva com sucesso");
          onSaveCallback && onSaveCallback();
        })
        .catch((ERR) => HotToastError(ERR));
    }
  }

  function SalvarComoModelo(text: string) {
    if (!fieldsVerify()) return;

    const txModeloPecaFormatado = formatarPeca(text);
    preservarTextoEditorAtual(txModeloPecaFormatado);

    sendModelo({
      txModeloPeca: txModeloPecaFormatado,
      txDescricao: modelTitle,
      dtCadastro: new Date().toISOString().split("T")[0],
      hrCadastro: new Date().toISOString().split("T")[1].split(".")[0],
      idTipoDocumento: modelTypeFilter.value,
      idUsuarioCadastro: parseInt(userId),
      txTipoDocumento: modelTypeFilter.label,
      txAutor: token["Jvris.User.Name"],
    })
      .then(() => HotToastSucess("Modelo salvo com sucesso"))
      .catch(() => HotToastError("Erro ao salvar o modelo"));
  }

  async function EnviarParaPJE(text: string, pdf: boolean) {
    if (!fieldsVerify()) return;

    const txPecaFormatada = formatarPeca(text);

    if (recPeca && recPeca !== "NotFound" && typeof recPeca !== "string") {
      const data = await getProcessData(recPeca.idProcesso.toString());

      const consultaCred = await getConsultarCredenciaisPje(
        recPeca.idProcurador,
        data?.data?.nuInstancia,
      );

      const token = localStorage.getItem("token");

      assinarPeca({
        id: recPeca.id,
        idAto: recPeca.idAto,
        txDescricao: modelTitle, // <- melhor refletir o título atual também
        idTipoDocumento: modelTypeFilter.value, // <- e o tipo atual
        idProcurador: recPeca.idProcurador,
        idModeloPeca: modelos.find(
          (model) => model.idTipoDocumento == modelTypeFilter.value,
        )?.id,
        idUsuarioCadastro: recPeca.idUsuarioCadastro,
        txPeca: txPecaFormatada, // <- usa o texto atual do editor
        isCredencialPJeCadastrada: (consultaCred?.data?.length ?? 0) > 0,
        userToken: token,
      })
        .then((assRes) => {
          invalidateDashboardProcuradorQueries(recPeca.idProcurador);
          const open = pdf ? openSignerReadOnly : openSigner;
          open(assRes.ticket).then(() =>
            HotToastSucess("Assinador aberto com sucesso"),
          );
        })
        .catch((err) => HotToastError(err));

      return;
    }

    if (finlPeca) {
      assinarPeca({
        id: finlPeca.id,
        idAto: finlPeca.idAto,
        txDescricao: modelTitle,
        idTipoDocumento: modelTypeFilter.value,
        idProcurador: finlPeca.idProcurador,
        idModeloPeca: modelos.find(
          (model) => model.idTipoDocumento == modelTypeFilter.value,
        )?.id,
        idUsuarioCadastro: finlPeca.idUsuarioCadastro,
        txPeca: txPecaFormatada,
      })
        .then((assRes) => {
          invalidateDashboardProcuradorQueries(finlPeca.idProcurador);
          const open = pdf ? openSignerReadOnly : openSigner;
          open(assRes.ticket).then(() =>
            HotToastSucess("Assinador aberto com sucesso"),
          );
        })
        .catch((err) => HotToastError(err));

      return;
    }

    HotToastWarning("Salve a peça antes de enviar para o PJE");
  }

  function FinalizarPeca(Callback?: () => void) {
    if (recPeca != "NotFound" && typeof recPeca != "string" && recPeca) {
      finalizarPeca(currModel ? currModel.id : recPeca.id)
        .then(() => {
          //seed();
          invalidateDashboardProcuradorQueries(recPeca.idProcurador);
          Callback && Callback();
          HotToastSucess("Peca finalizada com sucesso");
        })
        .catch(() => {
          HotToastError("Erro ao finalizar a peca");
        });
    }
  }

  function updateFinalPeca(value: PecaI) {
    setFinlPeca(value);
  }

  function ConcluirAtuacao(Callback?: () => void) {
    concluirAtuacao(processo.id, {
      Id: +idAto,
      idUsuarioCadastro: parseInt(userId),
      txTipo: "P",
    })
      .then(() => {
        //seed();
        invalidateDashboardProcuradorQueries(selectedUser?.id, userId);
        Callback && Callback();
        HotToastSucess("Atuação concluída com sucesso");
      })
      .catch(() => {
        HotToastError("Erro ao concluir a atuação");
      });
  }

  function AnexarArquivo(
    tipoDoc: number,
    anexBase64: string,
    onSucess: () => void,
  ) {
    if (!recPeca || recPeca == "NotFound" || typeof recPeca == "string") {
      HotToastError(
        "Peça não foi salva, salve a peça antes de anexar um arquivo",
      );
      return;
    }
    //console.log("recPeca", recPeca);
    const anexo: SendAnexoPecaI = {
      file_stream: anexBase64,
      idPeca: recPeca.id,
      idTipoDocumento: tipoDoc,
      idUsuarioCadastro: parseInt(userId),
    };

    adicionarAnexo(anexo)
      .then(() => {
        HotToastSucess("Arquivo anexado com sucesso");
        //seed();
        onSucess();
      })
      .catch(() => {
        HotToastError("Erro ao anexar o arquivo");
      });
  }

  return (
    <PecasContext.Provider
      value={{
        modelTypeFilter,
        currModel,
        modelTitle,
        recPeca,
        modelo,
        modelos,
        finlPeca,
        tiposProcessoPJE,
        loadingModelosPecas,
        idAto: 0 /* location.state
                    ? parseInt(processo.idProcesso)
                    : undefined, */,
        loadingTiposProcessoPJE,
        anexosPeca,
        anexosAto,
        partes,
        anexosResposta,
        prepareModelList,
        prepareModelListUser,
        prepareModelTypeList,
        updateModelTypeFilterValue,
        updateCurrModel,
        SalvarComoModelo,
        updateTitle,
        SalvarPeca,
        EnviarParaPJE,
        FinalizarPeca,
        updateFinalPeca,
        ConcluirAtuacao,
        AnexarArquivo,
        getPecasFinalizadas,
        pecasFinalizadas,
        getAto,
        updateModelo,
        seed: () => {},
        seed2: seed,
        idProcesso: processo?.id,
        getProcesso,
        processo,
        getModeloById,
      }}
    >
      {props.children}
    </PecasContext.Provider>
  );
};

export const usePecasContext = () => {
  const context = useContext(PecasContext);
  if (!context) {
    throw new Error("useSpecificContext must be used within a PecasProvider");
  }
  return context;
};
